import { BottomBarItem, AppConfigBottomBarItemKey } from './types';

export type DefaultBottomBarItemKey = AppConfigBottomBarItemKey;

export type DefaultStandardMenuItems = Record<DefaultBottomBarItemKey, BottomBarItem>;

export const defaultStandardItems: DefaultStandardMenuItems = {
  matches: {
    text: 'Matcher',
    icon: 'Matches',
    type: 'matches',
  },
  unibet: {
    text: 'Unibet',
    icon: 'Unibet',
    type: 'unibet',
  },
  news: {
    text: 'Nyheter',
    icon: 'News',
    type: 'news',
  },
  teams: {
    text: 'Klubbar',
    icon: 'Teams',
    type: 'teams',
  },
  fantasy: {
    text: 'Fantasy',
    icon: 'Fantasy',
    type: 'fantasy',
  },
  gameDay: {
    text: 'Partner',
    icon: 'Gameday',
    type: 'gameDay',
  },
  standings: {
    text: 'Tabellen',
    icon: 'Standings',
    type: 'standings',
  },
  fotbollPlay: {
    text: 'Play',
    icon: 'Fotballplay',
    type: 'fotbollPlay',
  },
  statistics: {
    text: 'Statistik',
    icon: 'Stats',
    type: 'statistics',
  },
  customUrl: {
    text: '',
    icon: 'TicketActivity',
    type: 'customUrl',
  },
};
